export const environment = {
  appVersion: require('../../package.json').version,
  production: true,
  environmentName: 'Dev',
  REST_API_URL: "https://cpsampleshop-dev.azurewebsites.net/api",
  UI_URL: "https://cpsampleshop-dev.azurewebsites.net/home",
  postLogoutRedirectUri: "https://cpsampleshop-dev.azurewebsites.net/login"
};